import React from 'react';

const CertificateCard = ({ certificate }) => {
  const getCertificateIcon = (type) => {
    const icons = {
      'Buena conducta': 'M9 12l2 2 4-4m6-2a9 9 0 11-18 0 9 9 0 0118 0z',
      'Socialización': 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
      'Paseo extremo': 'M13 5l7 7-7 7M5 5l7 7-7 7',
      'Cumpleaños': 'M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z',
      'Baño estelar': 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4'
    };
    return icons[type] || icons['Buena conducta'];
  };

  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 border border-gray-100">
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <div className="bg-cyan-100 p-3 rounded-lg mr-4">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-8 w-8 text-cyan-600" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={getCertificateIcon(certificate.certificateType)} />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-800">{certificate.dogName}</h3>
              <p className="text-cyan-600 font-medium">{certificate.certificateType}</p>
            </div>
          </div>
          <span className="text-sm text-gray-500">{new Date(certificate.dateIssued).toLocaleDateString()}</span>
        </div>

        <div className="flex justify-center my-4">
          <img 
            src={certificate.image} 
            alt={certificate.dogName} 
            className="h-32 w-32 object-cover rounded-full border-4 border-cyan-100"
          />
        </div>

        <div className="flex justify-center space-x-3 mt-6">
          <button className="flex items-center px-4 py-2 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Descargar
          </button>
          <button className="flex items-center px-4 py-2 bg-cyan-100 text-cyan-800 rounded-lg hover:bg-cyan-200 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
            </svg>
            Compartir
          </button>
        </div>
      </div>
    </div>
  );
};

export default CertificateCard;